@if(service.viewDroplistItems.length){
<div class='devo-pipeline-views-part'>
	@if(service.selectedViewItem(); as selectedViewItem){
		
	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='customSort' style='display:inline-block'>
	</droplist>

	<ng-container [ngSwitch]="selectedViewItem.uniqueId">
		<devo-pipeline-opportunities-view-part
			*ngSwitchCase="service.viewId.Opportunities"></devo-pipeline-opportunities-view-part>
		<devo-pipeline-staff-view-part
			*ngSwitchCase="service.viewId.Staff"></devo-pipeline-staff-view-part>
	</ng-container>
	}

</div>
}